export const mainSitelinkCandidates = [
  {
    label: "Robot prices",
    to: "/shop/humanoid-robots",
    description: "Recorded robot prices, product information and manufacturer links."
  },
  {
    label: "Humanoid Robots",
    to: "/humanoid-robots",
    description: "Profiles, specifications and verified updates about humanoid robots."
  },
  {
    label: "Robotics News",
    to: "/robotics-news",
    description: "Technical reporting on robot launches, deployments, demos and limits."
  },
  {
    label: "Robot Companies",
    to: "/robotics-companies",
    description: "Verified robotics companies organized by continent, country and product category."
  },
  {
    label: "Physical AI",
    to: "/physical-ai",
    description: "Embodied intelligence, robot foundation models, world models and closed-loop control."
  },
  {
    label: "Robot Videos",
    to: "/viral-robotics-topics",
    description: "Robot demos and viral clips explained through hardware and autonomy details."
  },
  {
    label: "Robotics Guides",
    to: "/robotics",
    description: "Practical guides to robot hardware, software, sensing and deployment."
  },
  {
    label: "About",
    to: "/about-techniahq",
    description: "TechniaHQRobot editorial standards, coverage areas and publishing approach."
  },
  {
    label: "Contact",
    to: "/contact",
    description: "Contact TechniaHQRobot about robotics news, corrections, partnerships, copyright, privacy and website support."
  }
];

export const secondaryNavigation = [
  { label: "Work with us", to: "/partnerships" },
  { label: "Data Hub", to: "/data" },
  { label: "Jobs Intelligence", to: "/jobs" },
  { label: "Humanoid Intelligence", to: "/humanoid-intelligence" },
  { label: "Robot Types", to: "/robot-types" },
  { label: "Robot Sensors", to: "/robot-sensors" },
  { label: "Robot Components", to: "/robot-components" },
  { label: "Robotics Software", to: "/robotics-software" },
  { label: "Robotics Events", to: "/robotics-events" },
  { label: "AI News", to: "/ai-news" },
];

export const languageEditionLinks = [
  {
    locale: "en",
    hreflang: "en",
    label: "English",
    shortLabel: "EN",
    href: "/",
    description: "The main TechniaHQRobot edition covering humanoid robots, Physical AI and robotics news.",
    featured: [
      ["Humanoid robots", "/humanoid-robots"],
      ["Physical AI", "/physical-ai"],
      ["Robotics & Physical AI data", "/data"],
      ["Physical AI jobs", "/jobs/physical-ai"],
      ["Robotics news", "/robotics-news"],
      ["Robot companies", "/robotics-companies"],
    ],
  },
  {
    locale: "zh-cn",
    hreflang: "zh-CN",
    label: "简体中文",
    shortLabel: "中文",
    href: "/zh-cn/",
    description: "人形机器人、具身智能、物理 AI、机器人企业和真实部署分析。",
    featured: [
      ["人形机器人", "/zh-cn/humanoid-robots"],
      ["物理 AI", "/zh-cn/physical-ai"],
      ["机器人新闻", "/zh-cn/robotics-news"],
      ["机器人企业", "/zh-cn/robotics-companies"],
      ["机器人展会", "/zh-cn/robotics-events"],
    ],
  },
  {
    locale: "fr",
    hreflang: "fr",
    label: "Français",
    shortLabel: "FR",
    href: "/fr/",
    description: "Robots humanoïdes, IA physique, entreprises, actualités et déploiements vérifiés.",
    featured: [
      ["Robots humanoïdes", "/fr/humanoid-robots"],
      ["IA physique", "/fr/physical-ai"],
      ["Actualité robotique", "/fr/robotics-news"],
      ["Entreprises", "/fr/robotics-companies"],
      ["Événements", "/fr/robotics-events"],
    ],
  },
  {
    locale: "ja",
    hreflang: "ja",
    label: "日本語",
    shortLabel: "日本語",
    href: "/ja/",
    description: "ヒューマノイド、フィジカル AI、ロボット企業、ニュース、導入事例。",
    featured: [
      ["ヒューマノイド", "/ja/humanoid-robots"],
      ["フィジカル AI", "/ja/physical-ai"],
      ["ロボットニュース", "/ja/robotics-news"],
      ["ロボット企業", "/ja/robotics-companies"],
      ["ロボット展示会", "/ja/robotics-events"],
    ],
  },
  {
    locale: "de",
    hreflang: "de",
    label: "Deutsch",
    shortLabel: "DE",
    href: "/de/",
    description: "Humanoide Roboter, physische KI, Robotikunternehmen, Nachrichten und Praxiseinsätze.",
    featured: [
      ["Humanoide Roboter", "/de/humanoid-robots"],
      ["Physische KI", "/de/physical-ai"],
      ["Robotik-News", "/de/robotics-news"],
      ["Robotikunternehmen", "/de/robotics-companies"],
      ["Robotikveranstaltungen", "/de/robotics-events"],
    ],
  },
  {
    locale: "pt",
    hreflang: "pt",
    label: "Português",
    shortLabel: "PT",
    href: "/pt/",
    description: "Robôs humanoides, IA física, robótica e guias de certificação em português.",
    featured: [
      ["Certificações em robôs humanoides", "/pt/ai/best-humanoid-robot-certifications-2026"],
      ["Certificações em IA física", "/pt/ai/best-physical-ai-certifications-2026"],
      ["Certificações em IA incorporada", "/pt/ai/best-embodied-ai-certifications-2026"],
      ["Certificações em robótica", "/pt/ai/best-robotics-certifications-2026"],
    ],
  },
  {
    locale: "es",
    hreflang: "es",
    label: "Español",
    shortLabel: "ES",
    href: "/es/",
    description: "Robots humanoides, IA física, robótica y guías de certificación en español.",
    featured: [
      ["Certificaciones de robots humanoides", "/es/ai/best-humanoid-robot-certifications-2026"],
      ["Certificaciones de IA física", "/es/ai/best-physical-ai-certifications-2026"],
      ["Certificaciones de IA incorporada", "/es/ai/best-embodied-ai-certifications-2026"],
      ["Certificaciones de robótica", "/es/ai/best-robotics-certifications-2026"],
    ],
  },
];

export const languageEditionAlternates = [
  ...languageEditionLinks.map(({ locale, hreflang, href }) => ({ locale, hreflang, href })),
  { locale: "x-default", hreflang: "x-default", href: "/" },
];

export const homepagePriorityGroups = [
  {
    title: "Humanoid robots and Physical AI",
    links: [
      ["Humanoid Intelligence database", "/humanoid-intelligence"],
      ["Humanoid robot database", "/humanoid-robots/database"],
      ["Compare humanoid robots", "/humanoid-robots/compare"],
      ["Humanoid robot catalog", "/humanoid-robots"],
      ["Humanoid manufacturers", "/humanoid-robots/manufacturers"],
      ["Humanoid robots by country", "/humanoid-robots/countries"],
      ["Humanoid robot data and charts", "/robotics/humanoid-robot-data"],
      ["Physical AI", "/physical-ai"],
      ["Robotics & Physical AI data", "/data"],
      ["Physical AI jobs", "/jobs/physical-ai"],
      ["Robotics news", "/robotics-news"],
    ],
  },
  {
    title: "Robotics directories",
    links: [
      ["Robot companies", "/robotics-companies"],
      ["Robotics software", "/robotics-software"],
      ["Robot components", "/robot-components"],
      ["Robot sensors", "/robot-sensors"],
      ["Robot types", "/robot-types"],
      ["Robotics events", "/robotics-events"],
    ],
  },
  {
    title: "Certification guides",
    links: [
      ["Humanoid robot certifications", "/ai/best-humanoid-robot-certifications-2026"],
      ["Physical AI certifications", "/ai/best-physical-ai-certifications-2026"],
      ["Embodied AI certifications", "/ai/best-embodied-ai-certifications-2026"],
      ["Robotics certifications", "/ai/best-robotics-certifications-2026"],
      ["Robotics courses and certifications", "/robotics/best-robotics-courses-certifications"],
    ],
  },
];
